import { useMemo } from 'react';

import useQueryParams from '../useQueryParams';

const useQueryParamKey = (key: string) => {
  const { params, setParam } = useQueryParams();

  const paramKey = useMemo(() => (typeof params[key] === 'string' ? params[key] : ''), [params, key]);
  const setParamKey = (value: string) => setParam(key, value);
  return { paramKey, setParamKey };
};

export default useQueryParamKey;
